<template>
  <div class="credits-subscribe" :class="`${createRenderType}-credits-subscribe`">
    <Header v-if="createRenderType == 'mobile' && route?.query?.membership_source1 == 'activity'"></Header>
    <el-scrollbar>
      <div class="credits-main height-all" :class="`${createRenderType}-credits-main`">
        <div class="credits-main-content height-all">
          <!-- 国内 -->
          <Memeber
            v-if="globleConfig.appname == 'YinFeng'"
            :currentCredits="currentCredits"
            @handleCreditCheckout="(item, type) => handleCheckout(item, isMobileDevice() ? 'wechat_h5' : 'wechat_native', type)"
            @handleView="handleView"
          ></Memeber>
          <!-- 海外 -->
          <CreditList
            v-else
            ref="creditListRef"
            :showData="showData"
            :isloading="isloading"
            :productList="productList"
            :inEffectInfo="inEffectInfo"
            @getProductList="getProductList"
            @handleCreditCheckout="
              (item, channel, type) =>
                handleCheckout(
                  item,
                  globleConfig.appname != 'Mureka'
                    ? ModuleOpenStateControl.pay.openMobile && isMobileDevice()
                      ? 'wechat_h5'
                      : 'wechat_native'
                    : channel,
                  type
                )
            "
            @handleView="handleView"
            @handleViewReleaseRecord="handleViewReleaseRecord"
          ></CreditList>
        </div>
      </div>
    </el-scrollbar>
  </div>
  <ExpirationDialog v-if="dialogVisible" v-model:visible="dialogVisible" :showData="showData"></ExpirationDialog>
  <ReleaseDialog v-if="releaseDialogVisible" v-model:visible="releaseDialogVisible"></ReleaseDialog>
  <UpgradeDialog
    v-if="upgradeDialogVisible"
    v-model:visible="upgradeDialogVisible"
    :upgradeDialogData="upgradeDialogData"
    :productList="productList"
    :allowed_behavior="allowed_behavior"
    @handleUpgrade="handleUpgrade"
  ></UpgradeDialog>
  <Reward v-if="rewardDialogVisible" v-model:visible="rewardDialogVisible" @handleView="handleView"></Reward>
  <LookingDialog v-if="lookingDialogVisible" v-model:visible="lookingDialogVisible"></LookingDialog>
  <SavingDialog v-if="savingDialogVisible" v-model:visible="savingDialogVisible"></SavingDialog>
  <CouponDialog
    v-if="couponDialogVisible"
    v-model:visible="couponDialogVisible"
    :productList="productList"
    :couponLocal="couponLocal"
    :discountData="discountData"
  ></CouponDialog>
</template>

<script setup>
import { ref, watch, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import globleConfig, { ModuleOpenStateControl, chinaAppName } from "@/config/config.js";
import { $$t, $$language } from "@/i18n/i18n.js";
import {
  getCreditInfo,
  checkoutCredit,
  subscribePop,
  checkSubscribe,
  upgradePreview,
  upgrade,
  checkoutCallBack,
  getNewProducts,
  sendDiscount,
  getCouponInfo,
} from "@/api/api/apiCredit.js";
import Memeber from "./components/memberBox.vue";
import CreditList from "./components/creditList.vue";
import ExpirationDialog from "./components/expirationDialog.vue";
import ReleaseDialog from "./components/releaseDialog.vue";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useCreditDataStore from "@/store/credit/creditDataStore.js";
import { handlePayMoney } from "@/utils/pay.js";
import { isMobileDevice } from "@/utils/tools";
import { stripe3DS } from "@/utils/stripe.js";
import message from "@/components/functionCallComponent/message/message.js";
import UpgradeDialog from "./components/upgrade.vue";
import LookingDialog from "./components/looking.vue";
import SavingDialog from "./components/savingDialog.vue";

import Reward from "./components/reward.vue";
import Header from "./components/header.vue";
import useAbtestStore from "@/store/abtestStore";
import CouponDialog from "./components/coupon.vue";

const globalProperties = getCurrentInstance()?.appContext.config.globalProperties;

const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const abtestStore = useAbtestStore();
// const paymentABResult = ref("")
const creditDataStore = useCreditDataStore();
const { createRenderType, lastSimilarCreateType } = storeToRefs(createLayoutStore);
const Router = useRouter();
const route = useRoute();
const creditListRef = ref(null);
const currentCredits = ref("");
const dialogVisible = ref(false);
const lookingDialogVisible = ref(false);
const savingDialogVisible = ref(false);
const couponDialogVisible = ref(false);
const releaseDialogVisible = ref(false);
const upgradeDialogVisible = ref(false);
const upgradeDialogData = ref({});
const rewardDialogVisible = ref(false);
const totalPrice = ref("");
const creditLevel = ref("");
const showData = ref({});
const allowed_behavior = ref(0);
const isloading = ref(false);

const productList = ref([]);

const inEffectInfo = ref({});

const discountData = ref({});
const conponInfo = ref("");
const couponlocalString = localStorage.getItem("show_coupon") ?? "";
const couponLocal = couponlocalString ? JSON.parse(couponlocalString) : {};

const callBackUrl =
  route.query.from_type == "similar" ? `${window.location.origin}${route.query.source_route}?create_type=${lastSimilarCreateType.value}` : "";

const DISCOUNT_TYPE_MAP = {
  discount_type_null: 0,
  discount_type_yearly_all: 12,
  discount_type_pro_all: 10,
  discount_type_all: 15,
};

watch(
  () => userDataStore.isLogin,
  async (val) => {
    if (val) {
      getCurrentCredits();
      checkShowCouponDialog();
    } else {
      // currentCredits.value = 0;
      showData.value = {};
    }
  }
);

const getCurrentCredits = () => {
  getCreditInfo().then((res) => {
    if (res.code == 200) {
      const { data } = res;
      showData.value = data;
      currentCredits.value = data?.gold || 0;
    }
  });
};

watch(
  () => creditDataStore.isShowCreditDialog,
  (val) => {
    if (val) {
      dialogVisible.value = true;
      creditDataStore.changeCreditSialogDate(false);
    }
  },
  {
    immediate: true,
  }
);

const handlePay = (order_id, wechat_native_url) => {
  handlePayMoney(
    {
      totalPrice: totalPrice.value,
      wechat_native_url,
      order_id,
      isCredit: true,
    },
    () => {
      paySuccess();
    },
    () => {
      payFail();
    }
  );
};

const handleCheckout = async (item, channel, type) => {
  const { new_price, level, level_name, period_name } = item;
  let product_id = item?.[`${channel}_info`]?.product_id;

  // type=sub 订阅  type=credit 积分
  // channel =  stripe paypal
  const { membership_source1, membership_source2 } = route.query;
  totalPrice.value = new_price;
  creditLevel.value = level;
  const data =
    type == "sub"
      ? {
          product_id,
          channel,
          membership_source1,
          membership_source2,
        }
      : {
          product_id,
          channel,
        };
  if (type == "credit" || globleConfig.appname != "Mureka") {
    isloading.value = true;
    globalProperties.logClickEvent("subcrirbe_sub", {
      product_id,
      channel,
      membership_source1: String(membership_source1 || ""),
      membership_source2: String(membership_source2 || ""),
    });
    checkout(data, channel);
    return;
  }

  globalProperties.logClickEvent("subcrirbe_sub", {
    product_id,
    level_name,
    period_name,
    membership_source1: String(membership_source1 || ""),
    membership_source2: String(membership_source2 || ""),
    details: userDataStore.userInfo?.discount?.discount_percent ? String(userDataStore.userInfo.discount.discount_percent) + "_off" : "",
    type: String(userDataStore.userInfo?.discount?.discount_type ?? ""),
  });

  isloading.value = true;
  // 老checkout传商品Id  新的period，level
  // const { data: check_res, code: check_code, msg: check_msg } = await checkSubscribe({ product_id: product_id });
  const { data: check_res, code: check_code, msg: check_msg } = await checkSubscribe({ period: period_name, level: level_name });
  if (check_code == 200) {
    allowed_behavior.value = check_res?.action_type;
    if (check_res?.action_type == 2 || check_res?.action_type == 3) {
      upgradePreviewFunc(item);
    } else if (check_res?.action_type == 1) {
      isloading.value = false;
      checkoutBefore(level_name, period_name);
    } else {
      isloading.value = false;
      message.error({
        content: "Switch to this plan is currently not supported",
      });
    }
  } else {
    isloading.value = false;
    codeDel(check_code, check_msg);
  }
};

const checkoutBefore = (level_name, period_name) => {
  const { membership_source1, membership_source2, from_type } = route.query;
  // TODO:
  Router.push({
    name: "payment",
    query: {
      membership_source1,
      membership_source2,
      from_type,
      level: level_name,
      period: period_name,
    },
  });
};

const checkout = (data, channel) => {
  console.log("data🔥", data, channel);
  checkoutCredit({
    ...data,
    return_url: callBackUrl,
  })
    .then((res) => {
      if (res.code == 200) {
        const { order_id, jump_url } = res.data;
        if (globleConfig.appname != "Mureka") {
          handlePay(order_id, jump_url);
          return;
        }
        if (jump_url) {
          window.location.href = jump_url;
        }
      } else {
        codeDel(res.code, res.msg);
      }
    })
    .finally(() => {
      isloading.value = false;
    });
};

const codeDel = (code, msg) => {
  const errorCodes = [8004, 8006, 8007, 8009, 8010, 8011, 8012, 8017];

  if (errorCodes.includes(code)) {
    message.error({
      content: $$t(`credit.errorCodesMsg_${code}`),
    });
  } else {
    message.error({
      content: msg,
    });
  }
};

const upgradePreviewFunc = async (item) => {
  const product_id = inEffectInfo.value.type == "stripe" ? item?.stripe_info?.product_id : item?.paypal_info?.product_id;
  let { data, code, msg } = await upgradePreview(inEffectInfo.value.type, {
    new_product_id: product_id,
    action_type: allowed_behavior.value,
  });
  isloading.value = false;
  if (code == 200) {
    upgradeDialogData.value = data;
    upgradeDialogVisible.value = true;
  } else {
    message.error({
      content: msg,
    });
  }
};

const handleUpgrade = async (product) => {
  const product_id = product?.product_id ?? "";
  try {
    const { code, data, msg } = await upgrade({
      new_product_id: product_id,
      action_type: allowed_behavior.value,
    });
    upgradeDialogVisible.value = false;
    if (code == 200) {
      if (data.stripe_client_secret) {
        let res = await stripe3DS(data);
        if (res.status !== 200) {
          message.error({
            content: "failed to 3ds verification, please try again later",
          });
          return;
        }
      }
      navigateToPaymentResult(product_id);
    } else if (code == 500) {
      message.error({
        content: "failed to switch plan, please try again later",
      });
    } else if (code == 8012) {
      message.error({
        content: "failed to switch plan, please try again later",
      });
    } else if (code == 8013) {
      message.error({
        content: "Failed to switch plan, please check your Stripe payment settings",
      });
    } else {
      message.error({
        content: msg,
      });
    }
  } catch (error) {
    upgradeDialogVisible.value = false;
    message.error({
      content: "failed to switch plan, please try again later",
    });
  }
};

const navigateToPaymentResult = (product_id) => {
  Router.push({
    name: "paymetResult",
    query: {
      pay_channel: "stripe",
      pay_type: "renew", // subscribe  // renew  // once
      product_id,
      from_type: route.query.from_type ?? "",
      source_route: route.query.source_route ?? "",
    },
  });
};

const handleView = () => {
  dialogVisible.value = true;
};

const handleViewReleaseRecord = () => {
  releaseDialogVisible.value = true;
};

const payFail = () => {
  // Router.push({
  //   name: "resultFail",
  // });
};

const paySuccess = (type) => {
  if (creditListRef.value) {
    creditListRef.value.getInfo(); // 调用子组件暴露的方法
  }
  getProductList();
  userDataStore.getUserInfo();
  userDataStore.refreshUserAccount();
  getCurrentCredits();
  // Router.push({
  //   name: "resultCredit",
  //   query: {
  //     level: creditLevel.value,
  //   },
  // });
};

const back = () => {
  Router.go(-1);
};

const getSubscribePop = () => {
  subscribePop().then((res) => {
    if (res.code == 200) {
      const { data } = res;
      if (data?.pop) {
        rewardDialogVisible.value = true;
      }
    }
  });
};

const handleMessage = () => {
  const usejson = localStorage.getItem("action_product") ?? "{}";
  const product = usejson ? JSON.parse(usejson) : "";
  if (product && product.title) {
    message.success({
      content: `Successfully switch to ${product?.title}`,
    });
    localStorage.removeItem("action_product");
  }
};

// 一次性支付结果查询
const checkPayResult = async () => {
  pollGetResult();
};

async function pollGetResult(maxAttempts = 10, interval = 2000) {
  const { thp_channel, token } = route.query;
  if (thp_channel && thp_channel == "paypal") {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        const res = await checkoutCallBack({
          paypal_order_id: token,
        });
        console.log(`Attempt ${attempt}:`, res);

        if (res.code == 200 || res.code == 8003) {
          console.log("Success:", res);
          removeQueryParam("thp_channel");
          userDataStore.refreshUserAccount();
          getCurrentCredits();
          return res;
        }
      } catch (error) {
        console.error(`Attempt ${attempt} failed:`, error);
      }

      if (attempt < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, interval)); // 等待一段时间再重试
      }
    }
  }
  return null;
}

const removeQueryParam = (paramKey) => {
  const newQuery = { ...route.query };
  delete newQuery[paramKey];

  Router.replace({ query: newQuery });
};

function findInEffectInfo(list) {
  let result = {};

  list.forEach((item) => {
    if (item.paypal_info && item.paypal_info.in_effect === 1) {
      result = {
        type: "paypal",
        product_id: item.paypal_info.product_id,
        plan_id: item.paypal_info.plan_id || null,
      };
    }

    // 检查 stripe_info 中是否存在 in_effect 等于 1
    if (item.stripe_info && item.stripe_info.in_effect === 1) {
      result = {
        type: "stripe",
        product_id: item.stripe_info.product_id,
      };
    }
  });

  inEffectInfo.value = result;
  console.log("inEffectInfo.value", inEffectInfo.value);
}

const getProductList = () => {
  getNewProducts({
    category: "subscription",
    platform: "html",
  }).then((res) => {
    productList.value = res?.data?.list ?? [];
    findInEffectInfo(productList.value);
  });
};

const removeLocal = (name) => {
  localStorage.removeItem(name);
};

const checkShowCouponDialog = async () => {
  // const couponTypeAB = await abtestStore.initDiscountType();
  // const couponShowAB = await abtestStore.initDiscountShow();

  // const discount_type = DISCOUNT_TYPE_MAP?.[couponTypeAB] ?? 0;
  // const show_until_day = couponShowAB === "discount_show_5days" ? 5 : 0;
  // const isCouponGet = userDataStore.isLogin && (!userDataStore?.userInfo?.discount || userDataStore?.userInfo?.discount?.show_until);
  // console.log("优惠券数据=>DiscountType:", couponTypeAB, "DiscountShow:", couponShowAB, "满足领取条件:", isCouponGet, "是否结算返回:", couponLocal);

  // if (show_until_day == 5 && userDataStore?.userInfo?.discount) {
  //   const { data, code } = await getCouponInfo();
  //   console.log("优惠券数据🔥🔥=>", data);
  //   if(code == 200) {
  //     conponInfo.value = data.discount;
  //   }
  // }
  // (show_until_day == 5 && userDataStore?.userInfo?.discount?.status == 2 && conponInfo.value?.receive_again))
  const coupon_show_ab = await abtestStore.initCouponShow();
  const isCouponGet = userDataStore.isLogin && !userDataStore?.userInfo?.discount;
  if (coupon_show_ab == 'coupon_show' && couponLocal?.selectPlan && isCouponGet) {
    const { code, data } = await sendDiscount({
      discount_type: 15,
      show_until_day: 0,
    });
    if (code == 200) {
      discountData.value = data.discount;
      userDataStore.setDisCount(data.discount);
      userDataStore.startCountdown(discountData.value?.countdown_second);
      couponDialogVisible.value = true;
      if (data.discount) {
        removeLocal("show_coupon");
      }
    }
  }
};

onMounted(async () => {
  if (route?.query?.type == "invite_popup") {
    dialogVisible.value = true;
  }
  getProductList();
  getCurrentCredits();
  getSubscribePop();
  // handleMessage();
  checkPayResult();
  if(globleConfig.appname !== chinaAppName) {
    checkShowCouponDialog();
  }
  // abtestStore.clearPaymentABResult();
  // paymentABResult.value = await abtestStore.getPaymentABResult();
});
</script>

<style lang="scss">
.credits-subscribe {
  font-family: HarmonyOS Sans SC;
  color: #fff;
  // padding: 26px 20px 46px 20px;
  height: 100%;
  width: 100%;
  // overflow: auto;
  .pc-credits-main {
    padding: 32px 20px 46px 20px;
    min-width: max-content;
    // align-items: center;
  }
}

.mobile-credits-subscribe {
  padding: 0px;
  // overflow: hidden;
  .padding-bottom {
    padding-bottom: 0;
  }
  .credits-main-content {
    height: 100%;
  }
  .mobile-credits-main {
    height: 100%;
  }
  .mobile-credit-list {
    height: 100%;
    display: flex;
  }

  .wrapper {
    height: 0;
    flex: 1;
    overflow: auto;
  }
  .header-back {
    padding: 20px 0 20px 16px;
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 18px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
    }
  }
}
.main-page.main-page--subscribe {
  &.main-page-bottom-player-visible--true {
    .credits-subscribe {
      padding-bottom: 66px;
    }
    &.main-page--mobile {
      .credits-subscribe {
        padding-bottom: 80px;
      }
    }
  }
}
</style>
